<script>
import { Sprite, Container } from 'pixi.js'
import SceneMixin from '@/mixins/Scene'

export default {
  name: 'Scene2',
  mixins: [ SceneMixin ],

  beforeDestroy() {
    console.log('beforeDestroy');
    _.each(this.$sprites, (sp, index)=>{
      this.$els[index]['container'].removeChild(sp)
    })

    this.$scene.filters = null
    this.$sprites['front_s2'].filters = null

    this.$container.removeChild(this.$scene)
    this.$sub0.kill()
    this.$sub1.kill()
    this.$sub2.kill()
    this.$sub3.kill()
    this.$sub4.kill()
  },

  created() {

    const sprites = {}
    this.$sprites = sprites

    this.$scene = new Container 
    this.$scene.interactiveChildren = false
    
    this.setCenterContainer(this.$scene)    
    this.$parent.$scene2 = this.$scene

    const bkg_container = new Container()
    const sub_container = new Container()

    this.$container.addChild(this.$scene)
    this.$scene.addChild(bkg_container)
    this.$scene.addChild(sub_container)

    this.$sub0 = new TimelineMax()
    this.$sub1 = new TimelineMax()
    this.$sub2 = new TimelineMax()
    this.$sub3 = new TimelineMax()
    this.$sub4 = new TimelineMax()

    // ******************************************************** //
    // ******************************************************** //

    const els = {
      'bg_intro': { container: bkg_container, alpha: 1 },
      'ambiance': { container: bkg_container, alpha: 1 },
      'floor_s2': { container: sub_container, alpha: 1, position: { x: 0, y: 1230, width: 1536, height: 935 }},
      'f6': { container: sub_container, alpha: 0, position: { x: 671, y: 1124, width: 218, height: 277 }},
      'f5': { container: sub_container, alpha: 0, position: { x: 656, y: 1098, width: 247, height: 306 }},
      'f4': { container: sub_container, alpha: 0, position: { x: 631, y: 1053, width: 295, height: 361 }},
      'f3': { container: sub_container, alpha: 0, position: { x: 604, y: 991, width: 347, height: 437 }},
      'f2': { container: sub_container, alpha: 0, position: { x: 128, y: 708, width: 1336, height: 780 }},
      'f1': { container: sub_container, alpha: 0, position: { x: 128, y: 708, width: 1336, height: 787 }},
      'door': { container: sub_container, alpha: 0, position: { x: 693, y: 1196, width: 175, height: 186 }},
      'middle': { container: sub_container, alpha: 1, position: { x: 0, y: 717, width: 1536, height: 994 }},
      'front_s2': { container: sub_container, alpha: 1 },
      'green': { container: sub_container, alpha: 0, y: 0, position: { x: 0, y: 1088, width: 1536, height: 1082 }},
    }

    _.each(els, (el, name)=>{
      const sprite = new Sprite.from(this.$resources[name].texture) 
            sprite.scale.set(this.$root.$scale)
            sprite.x -= this.$canvas_width/2
            sprite.y -= this.$canvas_height/2
            sprite.alpha = el.alpha
      el.container.addChild(sprite)
      sprites[name] = sprite
      this.applySettings(sprite, el)
    })

    this.$els = els

    // ******************************************************** //
    // ******************************************************** //

    this.$green_of_scene2 = sprites['green']

    // ******************************************************** //
    // ******************************************************** //
    
    const alphaFilter = new PIXI.filters.AlphaFilter(0)
    const noiseFilter = new PIXI.filters.NoiseFilter(0.15)

    this.$scene.filters = [ alphaFilter ]
    sprites['front_s2'].filters = [ noiseFilter ]
    sub_container.y = -190

    const d1 = 2

    this.$sub0
      .set({}, { delay: d1 })

     this.$sub1
      .set({}, { delay: this.$sub0.duration()*0.25 })
      .to(sprites['f1'], this.$sub0.duration()*0.1, { pixi:{ alpha: 1 }, ease: Linear.easeNone })
      .to(sprites['f2'], this.$sub0.duration()*0.1, { pixi:{ alpha: 1 }, ease: Linear.easeNone }, '-='+ this.$sub0.duration()*0.05)
      .to(sprites['f3'], this.$sub0.duration()*0.1, { pixi:{ alpha: 1 }, ease: Linear.easeNone }, '-='+ this.$sub0.duration()*0.05)
      .to(sprites['f4'], this.$sub0.duration()*0.1, { pixi:{ alpha: 1 }, ease: Linear.easeNone }, '-='+ this.$sub0.duration()*0.05)
      .to(sprites['f5'], this.$sub0.duration()*0.1, { pixi:{ alpha: 1 }, ease: Linear.easeNone }, '-='+ this.$sub0.duration()*0.05)
      .to(sprites['f6'], this.$sub0.duration()*0.1, { pixi:{ alpha: 1 }, ease: Linear.easeNone }, '-='+ this.$sub0.duration()*0.05)
      .to(sprites['door'], this.$sub0.duration()*0.1, { pixi:{  scale: this.$root.$scale*1, alpha: 1 }, ease: Linear.easeNone })

    this.$sub2
      .to(this.$scene, this.$sub0.duration(), { pixi: { scale: 1.20 }, ease: Linear.easeNone })

    this.$sub3
      .to(alphaFilter,this.$sub0.duration()*0.25, { alpha: 1, ease: Linear.easeNone })
      .to(noiseFilter, this.$sub0.duration()*0.25, { noise: 0, ease: Linear.easeNone })

    this.$sub4
      .to(sub_container, this.$sub0.duration(), { pixi: { y: 0 }, ease: Linear.easeNone })

    this.$tl.add([ this.$sub0, this.$sub1, this.$sub2, this.$sub3, this.$sub4 ], 29)

  },
  mounted() {
    // this.chapter.$tl.play(20)
  }
}
</script>





























